import { Colors } from '@sigma-frontend-libs/commons'
import { SendingTypes } from '@sigmasms/shared-types'

import { allowedSendingTypesForImage, components, getLocaleDateString, getLocaleTimeString, getUrlToStorage, icons, services } from '@/utils'

import svg from '@/components/icon/svg'
import voice from '@/components/services/sendings/preview/voice'
import textOverflow from '@/components/text/overflow'

function renderSenderName(h, prefix) {
  const value = this.value.payload?.sender
  if (value) {
    return h(
      'div',
      {
        class: {
          [`${services.sendings}-preview__${prefix}-sender`]: true,
          [`${services.sendings}-preview__${prefix}-sender--${this.value.type}`]: prefix === 'message'
        }
      },
      [
        h(
          textOverflow,
          {
            props: { value }
          }
        )
      ]
    )
  }

  return h('div')
}

function renderHeaderBackIcon(h) {
  return h(
    components.icon,
    {
      props: {
        value: icons.keyboard_arrow_left,
        color: Colors.grey
      }
    }
  )
}
function renderHeaderAvatar(h) {
  return h(
    'div',
    {
      class: [
        `${services.sendings}-preview__header-avatar`,
        `${services.sendings}-preview__header-avatar--${this.value.type}`
      ]
    },
    [
      h(
        svg,
        {
          props: {
            value: 'user',
            color: Colors.white
          }
        }
      )
    ]
  )
}
function renderHeader(h) {
  return h(
    'div',
    {
      class: `${services.sendings}-preview__header`
    },
    [
      renderHeaderBackIcon.call(this, h),
      renderSenderName.call(this, h, 'header'),
      renderHeaderAvatar.call(this, h)
    ]
  )
}

function renderMessageDate(h) {
  return h(
    'div',
    {
      class: `${services.sendings}-preview__message-date`
    },
    [ getLocaleDateString(new Date()) ]
  )
}
function renderMessageText(h) {
  const text = this.value.payload?.text

  return h(
    'div',
    {
      class: {
        [`${services.sendings}-preview__message-text`]: true,
        'text--grey': !text
      },
      domProps: {
        innerHTML: text
          ? this.value.payload.text.replace(/\n/g, '<br>')
          : this.getTranslate(`${services.sendings}.labels.message`)
      }
    }
  )
}
function renderMessageContent(h) {
  return h(
    'div',
    {
      class: `${services.sendings}-preview__message-content`
    },
    [
      renderSenderName.call(this, h, 'message'),
      renderMessageText.call(this, h)
    ]
  )
}
function renderMessageImage(h) {
  if (allowedSendingTypesForImage.includes(this.value.type)) {
    const image = this.value.payload?.image
    if (image) {
      return h(
        'div',
        {
          class: `${services.sendings}-preview__message-image`
        },
        [
          h(
            'img',
            {
              attrs: {
                src: getUrlToStorage([ image ])
              }
            }
          )
        ]
      )
    }
  }
}
function renderMessageCloud(h) {
  return h(
    'div',
    {
      class: `${services.sendings}-preview__message-cloud`
    },
    [
      renderMessageContent.call(this, h),
      renderMessageImage.call(this, h)
    ]
  )
}
function renderMessageButton(h, text, url) {
  return h(
    'div',
    {
      class: `${services.sendings}-preview__message-button`,
      on: {
        click: () => {
          this.buttonClickHandler(url)
        }
      }
    },
    [ text ]
  )
}
function renderMessageButtons(h) {
  if (this.buttons && this.buttons.length) {
    return this.buttons.map(({ text, url }) => {
      return renderMessageButton.call(this, h, text, url)
    })
  }
}
function renderMessageHolder(h) {
  return h(
    'div',
    {
      class: `${services.sendings}-preview__message-holder`
    },
    [
      renderMessageCloud.call(this, h),
      renderMessageButtons.call(this, h)
    ]
  )
}
function renderMessageTime(h) {
  return h(
    'div',
    {
      class: `${services.sendings}-preview__message-time`
    },
    [ getLocaleTimeString(new Date(), { second: false }) ]
  )
}
function renderContentByType(h) {
  switch (this.value.type) {
    case SendingTypes.voice:
    case SendingTypes.flashcall: return h(voice, { props: { value: this.value } })
    default: {
      return h(
        'div',
        {
          class: `${services.sendings}-preview__message`
        },
        [
          renderMessageDate.call(this, h),
          renderMessageHolder.call(this, h),
          renderMessageTime.call(this, h)
        ]
      )
    }
  }
}
function renderBody(h) {
  return h(
    'div',
    {
      class: `${services.sendings}-preview__body`
    },
    [ renderContentByType.call(this, h) ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: `${services.sendings}-preview`
    },
    [
      renderHeader.call(this, h),
      renderBody.call(this, h)
    ]
  )
}
